import React, { useRef, useEffect } from 'react';
import './EventNavigation.css';
import { useAppStore } from '../../store/appStore';

const EventNavigation = ({ 
  groupedByPriority, 
  priorityOrder, 
  getPriorityColor, 
  getPriorityLabel,
  handleEventActivation,
  activeEventId 
}) => {
  const navigationRef = useRef(null);
  const activeItemRef = useRef(null);
  const updateVideoState = useAppStore(state => state.updateVideoState);
  
  useEffect(() => {
    if (activeEventId !== null && activeItemRef.current && navigationRef.current) {
      const navContainer = navigationRef.current;
      const activeItem = activeItemRef.current;
      
      const containerWidth = navContainer.offsetWidth;
      const itemLeft = activeItem.offsetLeft;
      const itemWidth = activeItem.offsetWidth;
      
      const targetScroll = itemLeft - (containerWidth / 2) + (itemWidth / 2);
      
      navContainer.scrollTo({
        left: Math.max(0, targetScroll),
        behavior: 'smooth'
      });
    }
  }, [activeEventId]);

  // 格式化时间为MMSS
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  // 处理章节点击
  const handleChapterClick = (eventIndex, startTime) => {
    console.log(`EventNavigation: 点击章节 ${eventIndex}, 时间 ${startTime}`);
    
    // 更新视频时间
    updateVideoState({ 
      currentTime: startTime,
      isPlaying: true // 确保视频继续播放
    }, 'eventNavigation');
    
    // 激活事件
    handleEventActivation(eventIndex);
  };
  
  return (
    <div className="event-navigation" ref={navigationRef}>
      {Array.isArray(priorityOrder) && priorityOrder.map(priority => {
        const priorityEvents = groupedByPriority?.[priority] || [];
        if (priorityEvents.length === 0) return null;

        return (
          <div key={priority} className="event-nav-section">
            <span 
              className="event-nav-header" 
              style={{ color: getPriorityColor(priority) }}
            >
              {getPriorityLabel(priority)} ({priorityEvents.length})
            </span>
            {priorityEvents.map((event, idx) => {
              const eventIndex = event.originalIndex;
              const isActive = activeEventId === eventIndex;
              
              return (
                <button 
                  key={idx} 
                  className={`event-nav-item ${isActive ? 'active' : ''}`}
                  onClick={() => handleChapterClick(eventIndex, event.startTime)}
                  title={event.event}
                  ref={isActive ? activeItemRef : null}
                  data-event-id={eventIndex}
                >
                  <span className="event-text">
                    {event.event}
                  </span>
                  <span className="event-time">{formatTime(event.startTime)}</span>
                </button>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default EventNavigation;